import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
export const MARK_NOTIFICATION_AS_SENT = 'MARK_NOTIFICATION_AS_SENT';


export const service = async (notificationId) => {
  const options: object = {
    url:  '/Api/Utility/MarkNotificationAsSent/' + notificationId,
    method: "GET",
  }
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(MARK_NOTIFICATION_AS_SENT, service, mock);
